module.exports = __webpack_public_path__ + "img/task-deadline.4d01dcef.png";